import React from "react";

import { useRentalInvoiceEditContext } from "./RentalInvoiceEditContainer";
import RentalInvoiceTaxFeeRow from "./RentalInvoiceTaxFeeRow";

const RentalInvoiceTaxFeesCard = () => {
  const {
    rentalInvoice,
    insertTaxFee,
  } = useRentalInvoiceEditContext();

  const addTaxFee = (e) => {
    e.preventDefault();
    insertTaxFee({ name: "Service Fee", rate: 0, category: null });
  };

  return (
    <div className="card">
      <div className="card-body" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div className="setlist-text-lg setlist-font-semibold figma-text secondary">Taxes &amp; Fees</div>
        {(rentalInvoice.rental_invoice_tax_fees || []).map((taxFee) => (
          <RentalInvoiceTaxFeeRow key={taxFee.id} taxFee={taxFee} />
        ))}
        <a onClick={addTaxFee} className="setlist-text-sm setlist-font-semibold figma-text link" style={{
          cursor: "pointer",
          display: "flex",
          gap: "4px",
          alignItems: "center",
          width: "fit-content",
        }}>
          <i className="fa-solid fa-plus" />
          Add Tax/Fee
        </a>
      </div>
    </div>
  );
};

export default RentalInvoiceTaxFeesCard;
